module.exports = __webpack_public_path__ + "img/icn_voto_mesas.261dd133.svg";